// <lottie-icon data-src="...json" data-lib="...lottie-light.min.js">
// Shows a static fallback icon, then (once on screen) loads the Lottie player and plays the
// animation once; hovering replays it. With reduced motion the fallback icon simply stays.
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let libPromise;

function loadLib(src) {
  if (window.lottie) return Promise.resolve(window.lottie);
  if (!libPromise) {
    libPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve(window.lottie);
      script.onerror = reject;
      document.head.append(script);
    });
  }
  return libPromise;
}

class LottieIcon extends HTMLElement {
  connectedCallback() {
    if (reducedMotion.matches || !this.dataset.src) return;
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.observer.disconnect();
        this.start();
      }
    }, { rootMargin: '120px' });
    this.observer.observe(this);
    // Replay on hover of the icon itself, or of a larger parent (e.g. the whole card) when data-hover-parent is set.
    const hoverTarget = (this.dataset.hoverParent && this.closest(this.dataset.hoverParent)) || this;
    hoverTarget.addEventListener('mouseenter', () => this.replay());
    this.addEventListener('focusin', () => this.replay());
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.animation?.destroy();
  }

  async start() {
    try {
      const lottie = await loadLib(this.dataset.lib);
      const target = this.querySelector('[data-lottie-target]');
      this.animation = lottie.loadAnimation({
        container: target,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: this.dataset.src,
      });
      this.animation.addEventListener('DOMLoaded', () => {
        this.classList.add('is-ready');
        this.replayBounce();
      });
      this.animation.addEventListener('data_failed', () => this.classList.remove('is-ready'));
    } catch (error) {
      /* the static icon stays in place */
    }
  }

  replayBounce() {
    const bouncer = this.parentElement;
    if (bouncer && bouncer.classList.contains('product-main__trust-icon')) bouncer.classList.add('is-bouncing');
  }

  replay() {
    if (this.animation && this.classList.contains('is-ready')) this.animation.goToAndPlay(0, true);
    // Give the icon's circle a little bounce too, when the host markup asks for it.
    const bouncer = this.closest('[data-bounce-host]') || this.parentElement;
    if (bouncer && bouncer.classList.contains('product-main__trust-icon')) {
      bouncer.classList.remove('is-bouncing');
      void bouncer.offsetWidth;
      bouncer.classList.add('is-bouncing');
    }
  }
}

if (!customElements.get('lottie-icon')) {
  customElements.define('lottie-icon', LottieIcon);
}
